import React from 'react';

import { useTranslation } from 'react-i18next';

import { StackNavigationProp } from '@react-navigation/stack';

import { LANGUAGE_KEYS } from 'config/languageKeys';

import { SCREEN } from 'router/screens';
import { RouteNavigationParams } from 'router/types';

import { COLOR } from 'utils/colors';
import { isWeb } from 'utils/responsiveness';
import { applyBoldStyle, applyNewLine } from 'utils/strings';

import DialogBody from 'components/Dialog/components/DialogBody';
import Text, { ETextCategory, ETextColor } from 'components/Text';

import styles from './styles';

const {
    FTI_UNSUCCESSFUL_PIN_TITLE,
    FTI_UNSUCCESSFUL_PIN_DESCRIPTION,
    TRY_AGAIN_BUTTON,
} = LANGUAGE_KEYS;

type Props = {
    navigation: StackNavigationProp<
        RouteNavigationParams,
        SCREEN.PIN_SETUP_UNSUCCESS
    >;
};

export default function PinSetupUnsuccess({ navigation }: Props) {
    const onPressContinue = () => {
        navigation.reset({ routes: [{ name: SCREEN.PIN_SETUP }] });
    };
    const { t } = useTranslation();

    return (
        <DialogBody
            title={FTI_UNSUCCESSFUL_PIN_TITLE}
            DescriptionComponent={() => (
                <Text
                    center
                    category={ETextCategory.body1}
                    color={ETextColor.light_grey}
                    style={styles.description}
                    {...(isWeb && { tabIndex: 0 })}
                >
                    {applyBoldStyle(
                        applyNewLine(t(FTI_UNSUCCESSFUL_PIN_DESCRIPTION)),
                        styles.description,
                    )}
                </Text>
            )}
            actionButtonTitle={TRY_AGAIN_BUTTON}
            handleActionButtonPress={onPressContinue}
            actionButtonFillColor={COLOR.primary}
            actionButtonTextStyle={styles.buttonText}
            actionButtonStyle={styles.button}
            style={styles.container}
        />
    );
}
